import {
  GetDoctorAppointmentListActionTypes,
  GET_DOCTOR_APPOINTMENT_LIST_FAIL,
  GET_DOCTOR_APPOINTMENT_LIST_LOADING,
  GET_DOCTOR_APPOINTMENT_LIST_SUCCESS,
  GetDoctorAppointmentListState,
  GET_DOCTOR_APPOINTMENT_LIST_API_MSG,
  GET_DOCTOR_APPOINTMENT_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetDoctorAppointmentListRes } from "./Model";

const initialState: GetDoctorAppointmentListState = {
  loading: false,
  getDoctorAppointmentListRes: {} as GetDoctorAppointmentListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getDoctorAppointmentListReducer = (
  state = initialState,
  action: GetDoctorAppointmentListActionTypes
): GetDoctorAppointmentListState => {
  switch (action.type) {
    case GET_DOCTOR_APPOINTMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_DOCTOR_APPOINTMENT_LIST_SUCCESS:
      return {
        ...state,
        getDoctorAppointmentListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_DOCTOR_APPOINTMENT_LIST_FAIL:
      return {
        ...state,
        getDoctorAppointmentListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_APPOINTMENT_LIST_API_MSG:
      return {
        ...state,
        getDoctorAppointmentListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_DOCTOR_APPOINTMENT_LIST_UPDATE_API_RES:
      return {
        ...state,
        getDoctorAppointmentListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
